module.exports = __webpack_public_path__ + "img/aarf.1e995bf.png";